import React, { useRef } from 'react';
import type { TTextBoxContentItem } from '@src/types/wysiwyg_editor';

import ControlPanelFrame from '@src/components/wysiwyg_editor/ControlPanelFrame';
import MainPanel from '@src/components/wysiwyg_editor/page_content_items/text/control_panel/MainPanel';
import type { ReactRefT, TRect } from '@src/types/misc';
import PreContentPanel from '@src/components/wysiwyg_editor/page_content_items/text/control_panel/PreContentPanel';
import useIsLargeScreen from '@src/hooks/useIsLargeScreen';

type TProps = {
  anchorLocation: TRect;
  anchorRef: ReactRefT<HTMLElement>;
  itemData: TTextBoxContentItem;
  stackOrder: number;
  beforeMoveToDrafts: () => void;
};

const PANELS = { pre_content: 'PRE_CONTENT', content: 'CONTENT' };
const CONTROL_PANEL_DIMENSIONS = {
  [PANELS.pre_content]: {
    large: { height: 105, width: 105 },
    mobile: { height: 105, width: 105 }
  },
  [PANELS.content]: {
    large: { height: 120, width: 302 },
    mobile: { height: 120, width: 228 }
  }
};

function ControlPanel({
  anchorLocation,
  anchorRef,
  itemData,
  stackOrder,
  beforeMoveToDrafts
}: TProps): React.ReactElement {
  const controlPanelRef = useRef<HTMLDivElement | null | undefined>(null);
  const currentPanel =
    itemData.content && itemData.content.pos.length
      ? PANELS.content
      : PANELS.pre_content;
  const isLarge = useIsLargeScreen();

  return (
    <ControlPanelFrame
      size={
        CONTROL_PANEL_DIMENSIONS[currentPanel][isLarge ? 'large' : 'mobile']
      }
      anchorRef={anchorRef}
      anchorRect={anchorLocation}
      ref={controlPanelRef}
      zIndex={stackOrder}
    >
      {currentPanel === PANELS.content ? (
        <MainPanel itemData={itemData} beforeMoveToDrafts={beforeMoveToDrafts} />
      ) : (
        <PreContentPanel itemId={itemData.id} />
      )}
    </ControlPanelFrame>
  );
}

export default ControlPanel;
